import { Destructor } from '@deqo/foundation';
import { injectable } from 'inversify';
import { UniversalSurfaceRenderer } from '../../../platform/UniversalSurfaceRenderer';
import { ActiveObject, resolve } from '../../Container';
import { Camera } from '../Camera';
import { OverlayHandle, OverlayPaint } from '../overlay/Overlay';
import { OverlayManager } from '../overlay/OverlayManager';

@injectable()
export class ToolOverlay extends ActiveObject {

    private handle = null as OverlayHandle;
    private painters = [] as OverlayPaint[];

    @resolve(Camera) private camera!: Camera;
    @resolve(OverlayManager) private overlays!: OverlayManager;

    public start(): void {
        this.handle = this.overlays.createOverlay('tool', this.doPaint);
        this.overlays.add(this.handle);

        this.burden(this.handle);
        this.burden(this.camera.observe(() => this.handle.invalidate()));
    }

    public add(painter: OverlayPaint): Destructor {
        this.painters.push(painter);
        return () => this.remove(painter);
    }

    public remove(painter: OverlayPaint): void {
        const i = this.painters.indexOf(painter);
        if (i >= 0) this.painters.splice(i, 1);
    }

    public removeAll(): void {
        this.painters.splice(0, this.painters.length);
    }

    public repaint(immediate?: boolean) {
        this.handle.invalidate(null, immediate);
    }

    private doPaint = (gfx: UniversalSurfaceRenderer) => {
        for (const p of this.painters) {
            gfx.reset();
            p(gfx);
        }
    };
}
